import VueFileIcon from './components/vue-file-icon.vue';
import VueFilePreview from './components/vue-file-preview.vue';
import VueFileList from './components/vue-file-list.vue';
import VueFileListItem from './components/vue-file-list-item.vue';
import VueFileAgent from './components/vue-file-agent.vue';
import VueFileAgentMixin from './components/vue-file-agent-mixin';
import VueFilePreviewMixin from './components/vue-file-preview-mixin';
import utils from './lib/utils';
import plugins from './lib/plugins';
import FileRecord from './lib/file-record';

import { App, Plugin } from 'vue';



export const vfaPlugin: Plugin = {
  
  install(app: App, options: any) {

    app.component('VueFileIcon', VueFileIcon);
    app.component('VueFilePreview', VueFilePreview);
    app.component('VueFileList', VueFileList);
    app.component('VueFileListItem', VueFileListItem);
    app.component('VueFileAgent', VueFileAgent);
    app.config.globalProperties.$vueFileAgent = {
      mixin: VueFileAgentMixin,
    };
  }
}

export const mixin = VueFileAgentMixin;

export { VueFileAgentMixin, VueFilePreviewMixin };

export { utils, FileRecord, plugins };

export const FileData = FileRecord; // for backward compatibility

export default vfaPlugin;
